<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <a v-show="false" :href="downloadUrl" target="_blank" ref="downloadRef"></a>
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN' // 汉语
import en_US from 'ant-design-vue/lib/locale-provider/en_US' // 英语
import vi_VN from 'ant-design-vue/lib/locale-provider/vi_VN' // 越南语
import enquireScreen from '@/utils/device'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default {
  data() {
    return {
      downloadUrl: '',
      locale: null,
      localType: {
        'zh-cn': zh_CN, // 汉语
        'en-us': en_US, // 英语
        'vi-vn': vi_VN // 越南语
      },
    }
  },
  created() {
    // 为了在单js文件中使用i18n所以保存vue实例
    window.vm = this
    let defaultLocale = this.$ls.get('language') || 'zh-cn'
    moment.locale(defaultLocale)
    this.locale = this.localType[ defaultLocale ]
    let that = this
    enquireScreen(deviceType => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      }
      // mobile
      else if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        that.$store.dispatch('setSidebar', false)
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        that.$store.dispatch('setSidebar', true)
      }

    })
    this.$bus.$on('changeLang', e => {
      this.changeLang(e)
    })
    this.busOnDownloadRef()
  },
  methods: {
    moment,
    changeLang(e) {
      this.$ls.set('language', e)
      moment.locale(e)
      this.$i18n.locale = e
      this.locale = this.localType[ e ] || this.localType[ 'zh_cn' ]
      // window.location.reload()
    },
    busOnDownloadRef() {
      this.$bus.$on('download', (url) => {
        this.downloadUrl = url
        this.$nextTick(() => {
          // this.$refs.downloadRef.click()
          window.open(url, '打印', 'location=no,status=no,scrollvars=no')
          this.downloadUrl = ''
        })
      })
    }
  }
}
</script>
<style>
#app {
  height: 100%;
}
</style>